import styled, { css } from 'styled-components';
import { flexVerticalMiddle } from '../../../utils/style';

export const StyledSidePanel = styled.div<{ open?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 12.5rem;
  z-index: 10;
  background: ${(props) => props.theme.colors.greys.white};
  border-right: 1px solid ${(props) => props.theme.colors.greys.grey20};
  padding: 5rem 0 1.5rem;
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform 0.3s;

  ${(props) =>
    props.open &&
    css`
      transform: translateX(0px);
    `};

  ${({ theme }) => theme.mediaQueries.min.lg} {
    width: 13.75rem;
    transform: none;
    transition: none;
  }
`;

export const StyledSideTopList = styled.ul`
  width: 100%;
`;

export const StyledSideBottomList = styled(StyledSideTopList)`
  ${({ theme }) => theme.mediaQueries.min.lg} {
    margin-top: auto;
  }
`;

export const StyledSideSubItemList = styled.ul<any>`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 1;
  width: 10rem;
  background: ${(props) => props.theme.colors.greys.white};
  border: 1px solid ${(props) => props.theme.colors.greys.grey20};

  ${({ theme }) => theme.mediaQueries.min.lg} {
    top: auto;
    bottom: 0;
    width: 100%;
  }
`;

export const StyledSideItem = styled.li<{ openSubItem?: boolean }>`
  position: relative;
  & > a {
    position: relative;
    height: 3rem;
    padding: 0 1.5rem;
    font-size: ${(props) => props.theme.fontSizes.text.fontSize};
    color: ${(props) => props.theme.colors.primary.main};
    text-decoration: none;
    line-height: 1.5;
    ${flexVerticalMiddle}

    &:before {
      content: none;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 0.5rem;
      background-color: ${(props) => props.theme.colors.primary.main};
      z-index: 1;
    }

    .icon-wrap {
      position: relative;
      display: flex;
      margin-right: 0.75rem;

      &.has-badge::before {
        content: '';
        position: absolute;
        top: -1px;
        right: -3px;
        width: 0.5rem;
        height: 0.5rem;
        background-color: ${(props) => props.theme.colors.error.light};
        border-radius: ${(props) => props.theme.radii.circle};
        z-index: 1;
      }
    }

    .angle-icon {
      margin-left: auto;
    }

    &.selected {
      background-color: ${(props) => props.theme.colors.primary.light};

      &:before {
        content: '';
      }
    }
  }

  &:hover {
    & > a {
      background-color: ${(props) => props.theme.colors.primary.light};
    }
  }

  ${(props) =>
    props.openSubItem &&
    css`
      ${StyledSideSubItemList} {
        display: block;
      }
    `}
`;

export const StyledSideSubItem = styled(StyledSideItem)`
  & > a {
    padding: 0 1rem;
  }

  & + & > a {
    box-shadow: inset 0px 1px 0px ${(props) => props.theme.colors.greys.grey10};
  }
`;

export const StyledMainPanel = styled.div`
  &.fullscreen {
    position: fixed;
    top: var(--sp-login-header-height);
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
  }

  & {
    .overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      background-color: ${(props) => props.theme.modal.wrapperBgd};
      opacity: 0.7;
    }
  }

  ${({ theme }) => theme.mediaQueries.min.md} {
    &.fullscreen {
      top: var(--pc-header-height);
    }
  }

  ${({ theme }) => theme.mediaQueries.min.lg} {
    padding-left: 13.75rem;

    & {
      .overlay {
        display: none;
      }
    }
  }
`;
